export interface WidgetRegistrationRequest {
  email: string
}

export const postWidgetRegistration = async (data: WidgetRegistrationRequest) => {
  const response = await fetch(`/api/newsletter-subscribe`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    throw new Error("Failed to submit email")
  }

  return response.json()
}
